export const NAV_PUSH = 'PUSH';
export const NAV_POP = 'POP';
export const NAV_REPLACE = 'REPLACE';

// The router keeps a monotonic index in history.state that survives a reload,
// so it is the only way to tell a backward POP from a forward one once the
// entry's key is no longer in our stack.
const isBackwards = (top, entry) =>
    typeof top?.idx === 'number' && typeof entry.idx === 'number' && entry.idx < top.idx;

export const reduceHistory = (stack, type, entry) => {
    const top = stack[stack.length - 1];
    if (top && top.key === entry.key) return stack;

    if (type === NAV_REPLACE) return [...stack.slice(0, -1), entry];

    if (type === NAV_POP) {
        const index = stack.findIndex((e) => e.key === entry.key);
        if (index !== -1) return stack.slice(0, index + 1);
        // Going backwards into history this page load never recorded: nothing
        // behind the landed entry is ours, so the stack must not claim a
        // previous page it cannot actually navigate to.
        if (isBackwards(top, entry)) return [entry];
    }

    return [...stack, entry];
};

export const previousEntry = (stack) => (stack.length > 1 ? stack[stack.length - 2] : null);
